var logoList = document.querySelector('.logo-bar');
if(logoList){
    const swiper = new Swiper('.logo-bar .swiper', {
        // Optional parameters
        loop: true,
        slidesPerView: 2,
        autoplay:
            {
                delay: 4000,
            },
        breakpoints: {
            640: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 4
            },
            1024: {
                slidesPerView: 5
            },
        },
        spaceBetween: 10,
        navigation: {
            nextEl: '.logo-list-button-next',
            prevEl: '.logo-list-button-prev'
        }
    });
}